import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgVipFilled = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 12"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 2c.124 0 .24.06.31.163l2.232 3.25 1.815-1.85a.375.375 0 0 1 .643.262v4.712c0 .386-.15.757-.42 1.032S9.943 10 9.558 10H2.442c-.385 0-.752-.156-1.022-.43A1.47 1.47 0 0 1 1 8.536V3.826a.375.375 0 0 1 .643-.263l1.815 1.85 2.233-3.25A.38.38 0 0 1 6 2"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgVipFilled;
